import HeaderShell from "./components/HeaderShell";
import Hero from "./components/Hero";
import LeadFlash from "./components/LeadFlash";
import HeatBoard from "./components/HeatBoard";
import EvidenceTimeline from "./components/EvidenceTimeline";
import ChatArchive from "./components/ChatArchive";
import ScreenshotGallery from "./components/ScreenshotGallery";
import AudioReel from "./components/AudioReel";
import Comments from "./components/Comments";
import Footer from "./components/Footer";

function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <HeaderShell />
      <main>
        <Hero />
        <LeadFlash />
        <HeatBoard />
        <EvidenceTimeline />
        <ChatArchive />
        <ScreenshotGallery />
        <AudioReel />
        <Comments />
      </main>
      <Footer />
    </div>
  );
}

export default Home;